module.exports = "# Getting Started\n\nblah.\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/articles/getting-started.md
// module id = 201
// module chunks = 0